import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/aboutPage/Skills.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sharepage/Preloader.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sharepage/Title.jsx");
